import { HdeSchemas } from '@api/types/generated/apiSchemas';
import { OddsBreakdown } from '@api/types/temporaryOddsReport';

type Breakdowns = HdeSchemas['Odds'];

const adaptOddsBreakdown = (report: Breakdowns): OddsBreakdown | null => {
  if (!report) {
    return null;
  }
  const {
    breakdowns,
    racecourse,
    totalStakeDetails,
    stakeDetails,
    streamTimestamp,
    ...reportProps
  } = report;

  return {
    ...reportProps,
    racecourseCode: racecourse.code,
    breakdowns: breakdowns.map(({ combination = [], odds = null, ...datum }) => ({
      ...datum,
      combination,
      odds,
    })),
    totalStakeDetails,
    stakeDetails,
    streamTimestamp,
  };
};

const adaptOddsBreakdowns = (breakdowns: Breakdowns[]): OddsBreakdown[] => {
  return breakdowns.map(adaptOddsBreakdown).filter((item): item is OddsBreakdown => item !== null);
};

export { adaptOddsBreakdowns };
